export class Sac {
  typeProcess: string;
  mainCategory: string;
  name: string;
  lastName: string;
  extenalOrderReference: string;
  extenalOrderDate: string;
  addrress: Addrress;
  cpf: string;
  text: string;
  ip: string;
  attachments: Attachments[];
}

export class Addrress {
  phone: number;
  email: string;
}


export class Attachments
{
    name: string;
    type: string;
    content: string;
}
